import Cookies from 'js-cookie';

const COOKIE_KEY = 'history';
const STORAGE_KEY = 'history_page_size';
const DEFAULT = 10;
const ALLOWED = [10, 25, 100, 500, 1000];

export function getHistoryPageSize(queryLimit) {
  const fromQuery = Number(queryLimit);
  if (fromQuery > 0 && ALLOWED.includes(fromQuery)) {
    return fromQuery;
  }
  const fromCookie = Number(Cookies.get(COOKIE_KEY));
  if (fromCookie > 0 && ALLOWED.includes(fromCookie)) {
    return fromCookie;
  }
  const fromStorage = Number(localStorage.getItem(STORAGE_KEY));
  if (fromStorage > 0 && ALLOWED.includes(fromStorage)) {
    return fromStorage;
  }
  return DEFAULT;
}

export function setHistoryPageSize(limit) {
  const value = ALLOWED.includes(Number(limit)) ? Number(limit) : DEFAULT;
  Cookies.set(COOKIE_KEY, String(value), { expires: 30 });
  localStorage.setItem(STORAGE_KEY, String(value));
  return value;
}
